// src/components/SecuredImage.tsx
import { Theme } from '@emotion/react';
import { Box, SxProps } from '@mui/material';
import { Dialog } from 'components/commons';
import React, { useEffect, useState } from 'react';
import { getKeyFromLocalStorage } from 'utils/constant';
import ja from 'utils/ja';

interface SecuredImageProps {
  src: string;
  alt?: string;
  style?: SxProps<Theme>;
}

const SecuredImage: React.FC<SecuredImageProps> = ({
  src,
  alt = '',
  style,
}) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  const toggleDialog = () => setOpen((oldState) => !oldState);

  useEffect(() => {
    if (!src) return;

    let objectUrl: string | null = null;

    const fetchImage = async () => {
      try {
        const appId = getKeyFromLocalStorage('appId');
        const appKey = getKeyFromLocalStorage('appKey');
        const dbId = getKeyFromLocalStorage('dbId');
        const dbKey = getKeyFromLocalStorage('dbKey');

        const response = await fetch(
          `${
            localStorage.getItem('url') ?? process.env.REACT_APP_CLUSTER_DB_API
          }${src}`,
          {
            headers: {
              'X-App-Id': appId ?? '',
              'X-App-Key': appKey ?? '',
              'X-App-Db': dbId ?? '',
              'X-App-Db-Key': dbKey ?? '',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.status}`);
        }

        const imageBlob = await response.blob();
        objectUrl = URL.createObjectURL(imageBlob);
        setImageUrl(objectUrl);
      } catch (err: unknown) {
        // empty
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  return (
    <>
      <Box
        component='img'
        src={imageUrl ?? ''}
        sx={{
          width: 120,
          height: 100,
          objectFit: 'cover',
          border: '1px solid #000000',
          ...style,
        }}
        alt={alt}
        onClick={toggleDialog}
      />
      {imageUrl && (
        <Dialog
          open={open}
          handleClose={toggleDialog}
          title={ja.common.image_dialog}
        >
          <Box sx={{ width: { xs: '84vw', sm: '500px' }, padding: '10px' }}>
            <Box
              component='img'
              src={imageUrl ?? ''}
              sx={{
                width: '100%',
                objectFit: 'cover',
                border: '1px solid #000000',
              }}
              alt={alt}
            />
          </Box>
        </Dialog>
      )}
    </>
  );
};

export default SecuredImage;
